import { render } from "./auth0Button.vue?vue&type=template&id=d57a9bfc"
import script from "./auth0Button.vue?vue&type=script&lang=js"
export * from "./auth0Button.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__